export default __webpack_public_path__ + "static/media/cream-wave-5.1c5f8627.svg";